"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailLocationsModule = void 0;
const inversify_1 = require("inversify");
const RetailLocation_1 = require("../../models/RetailLocation");
let RetailLocationsModule = class RetailLocationsModule {
    constructor(_httpConnection) {
        this._httpConnection = _httpConnection;
    }
    async setOrderingStatus(retailLocationId, payload) {
        const { availableForDelivery, availableForPickup, reason } = payload;
        const orderingStatus = {
            availableForDelivery,
            availableForPickup
        };
        const data = { orderingStatus, reason: reason || null };
        await this._httpConnection.makeRequest({
            url: `retailLocations/${retailLocationId}/set-ordering-status`,
            method: "post",
            data
        });
    }
    retrieveSyncedRetailLocations() {
        return {
            endpoint: "retailLocations",
            action: "retrieveSyncedRetailLocations",
            parameters: {},
            unseralizeData: (data) => data.retailLocations.map((retailLocation) => RetailLocation_1.RetailLocation.unserialize(retailLocation))
        };
    }
    async checkCanServiceOrder(retailLocationId, orderType, requestedReadyTime, currentPosition) {
        return await this._httpConnection.makeRequest({
            url: `retailLocations/${retailLocationId}/check-service`,
            method: "post",
            data: { orderType, requestedReadyTime, currentPosition }
        });
    }
};
RetailLocationsModule = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)("HttpConnection"))
], RetailLocationsModule);
exports.RetailLocationsModule = RetailLocationsModule;
//# sourceMappingURL=RetailLocationsModule.js.map